export default __webpack_public_path__ + "static/media/process_1.dd622f4f.svg";